import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import SafesTaswya from "./SafesTaswya";
const defaultAutos = {
  Safes: [],
};

export default function SafesTaswyaCon() {
  
  
  const tb = {
    wait: true,
    Safe: true,
    SafeEmp:true,
    Branch: true,
    costcenters:true,
    other: true,
    Units: true,
    Groups:true,
    EmpItems:true,
    Users:true,
    MedAccounts:true,
    AllAccountsIndex:true,
    stor: sto,

    parms: { safe: -1,
        tname:"tswya" , 
        medname:"tswya" , 
        iempid: sto.empi,
        branch:sto.branchi
    },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb
  );

  if (fetchAll || !AutoOptions?.Safes) return <LoadingPage />;

  return (
    <SafesTaswya
      {...{
        AutoOptions: AutoOptions?.Safes ? AutoOptions : defaultAutos,
        isEstelam:false,
      }}
    />
  );
}
